export enum ScheduledReportDateRangeEndEnum {
	Today = 0,
	XDaysBeforeReportRun = 10,
	EndOfLastMonth = 20,
	XDaysAfterStartDate = 30,
}